// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__vmWZ_","errorLogs":"styles_errorLogs__2fMHp"};